const header = document.querySelector('[data-header]');
const navToggle = document.querySelector('[data-nav-toggle]');
const nav = document.querySelector('[data-nav]');

if (navToggle && nav) {
  navToggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', String(open));
  });
}

if (header) {
  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

document.querySelectorAll('[data-qty]').forEach((group) => {
  const input = group.querySelector('input[name="quantity"], input[name="updates[]"]');
  if (!input) return;

  group.querySelectorAll('button[data-qty-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const next = Number(input.value || 1) + Number(button.dataset.qtyChange);
      input.value = String(Math.max(1, next));
    });
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const stage = gallery.querySelector('[data-gallery-stage] img');
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const image = thumb.querySelector('img');
      if (stage && image) {
        stage.src = image.currentSrc || image.src;
      }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});

document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
  const select = document.querySelector('[data-variant-select]');
  const label = picker.querySelector('[data-option-value]');

  picker.querySelectorAll('[data-variant-id]').forEach((button) => {
    button.addEventListener('click', () => {
      picker.querySelectorAll('[data-variant-id]').forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
      if (label) label.textContent = button.dataset.variantTitle;
      if (select) {
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});
